/**
 * Плавне розкриття core/details (<details class="wp-block-details">).
 * Без JS (і з prefers-reduced-motion) працює нативно — просто миттєво.
 * Анімуємо висоту самого <details> через Web Animations API.
 */
const DURATION = 380;
const EASING = 'cubic-bezier(.2, .7, .2, 1)';

function animate(details, opening) {
  details._anim?.cancel();

  const startHeight = details.offsetHeight;
  let endHeight;

  if (opening) {
    details.open = true;
    endHeight = details.offsetHeight;
  } else {
    // висота у згорнутому стані: міряємо, не малюючи (синхронний layout)
    details.open = false;
    endHeight = details.offsetHeight;
    details.open = true;
  }

  details.style.overflow = 'hidden';
  details.classList.toggle('is-opening', opening);
  details.classList.toggle('is-closing', !opening);

  const anim = details.animate(
    { height: [`${startHeight}px`, `${endHeight}px`] },
    { duration: DURATION, easing: EASING }
  );
  details._anim = anim;

  const finish = () => {
    details._anim = null;
    details.open = opening;
    details.style.overflow = '';
    details.classList.remove('is-opening', 'is-closing');
  };
  anim.onfinish = finish;
  anim.oncancel = () => {
    details.style.overflow = '';
  };
}

/**
 * FAQ у дві колонки (.svc-faq): розкладаємо питання у дві окремі колонки-обгортки.
 * CSS `columns` при розкритті питання перебалансовує колонки, і елементи «стрибають» між ними;
 * в окремих колонках розкриття зсуває лише свою. Без JS (і в редакторі) лишається CSS `columns`.
 */
function splitFaq() {
  document.querySelectorAll('.svc-faq:not(.is-split)').forEach((group) => {
    const items = [...group.children].filter((el) => el.matches('details.wp-block-details'));
    if (items.length < 2) return;
    const half = Math.ceil(items.length / 2);
    [items.slice(0, half), items.slice(half)].forEach((part) => {
      const col = document.createElement('div');
      col.className = 'svc-faq-col';
      col.append(...part);
      group.append(col);
    });
    group.classList.add('is-split');
  });
}

export default function accordion() {
  splitFaq();
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('details.wp-block-details').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      // під час закриття (анімація ще йде) details.open ще true — рахуємо за класом
      const closing = details.open && !details.classList.contains('is-closing');
      animate(details, !closing);
    });
  });
}
